// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"265":"50f0f936","398":"efdac9d1","720":"4049d3cb","801":"72e6f269"}[chunkId] + ".js";
};